<ui-section>
  <ui-block>
    <ui-panel
      width="fill"
      class="change-set-workspace"
      panelTitle="Change Sets"
      title="Change Sets"
      subtitle="Review pending authored platform changes, then publish or roll back with a reason."
    >
      <div class="workspace-toolbar">
        <div class="workspace-form">
          <ui-form
            #previewForm
            [config]="previewFormConfig"
            [(formValues)]="previewFormValues"
            [disabled]="isLoading() || isApplying()"
            [showFormErrors]="true"
          ></ui-form>

          <ui-button-group
            class="workspace-actions"
            [buttonsConfig]="previewActionButtons()"
            (buttonClick)="onPreviewActionButtonClick($event)"
          ></ui-button-group>
        </div>
      </div>

      <div *ngIf="isLoading()" class="state loading" data-testid="loading-state">
        Loading change set
      </div>

      <div *ngIf="!isLoading() && !hasLoaded()" class="state" data-testid="initial-state">
        No change set loaded.
      </div>

      <ui-panel
        *ngIf="!isLoading() && previewResult() as result"
        width="fill"
        class="workspace-section"
        panelTitle="Impact Summary"
        title="Impact Summary"
        [totalCount]="preview()?.pendingChangeCount ?? 0"
        data-testid="impact-summary-section"
      >
        <span [class]="'badge ' + result.state">{{ result.state }}</span>
        <p *ngIf="result.state !== 'resolved'" class="message">{{ formatMessage(result) }}</p>
        <p *ngIf="result.state === 'resolved' && entries().length === 0" class="message">
          No pending authored changes for this configuration.
        </p>

        <ui-grid
          *ngIf="impactSummary().length > 0"
          width="fill"
          containerClass="no-panel"
          [rowData]="impactSummary()"
          [columnDefs]="impactColumnDefs"
          [showPanelHeader]="false"
          [showBlankRowsOnLastPage]="true"
        ></ui-grid>
      </ui-panel>

      <ui-panel
        *ngIf="entries().length > 0"
        width="fill"
        class="workspace-section"
        panelTitle="Pending Changes"
        title="Pending Changes"
        [totalCount]="entries().length"
        data-testid="pending-changes-section"
      >
        <ui-grid
          width="fill"
          containerClass="no-panel"
          [rowData]="entries()"
          [columnDefs]="entryColumnDefs"
          [showPanelHeader]="false"
          [showBlankRowsOnLastPage]="true"
        ></ui-grid>
      </ui-panel>

      <ui-panel
        *ngIf="selectedEntry() as entry"
        width="fill"
        class="workspace-section"
        panelTitle="Review & Apply"
        title="Review & Apply"
        data-testid="review-apply-section"
      >
        <dl class="detail-list">
          <div>
            <dt>Domain</dt>
            <dd>{{ entry.domainCode }}</dd>
          </div>
          <div>
            <dt>Subject</dt>
            <dd>{{ entry.subjectCode }}</dd>
          </div>
          <div>
            <dt>Change</dt>
            <dd>{{ entry.changeKind }}</dd>
          </div>
          <div>
            <dt>Before</dt>
            <dd>{{ entry.beforeValue ?? "(none)" }}</dd>
          </div>
          <div>
            <dt>After</dt>
            <dd>{{ entry.afterValue ?? "(none)" }}</dd>
          </div>
          <div>
            <dt>Impacted Area</dt>
            <dd>{{ entry.impactedArea }}</dd>
          </div>
        </dl>

        <p *ngIf="!entry.canPublish && !entry.canRollback" class="message" data-testid="authoring-only-note">
          This domain is authoring-only here. Publish and rollback are not available for this change.
        </p>

        <ui-form
          #reasonForm
          [config]="reasonFormConfig"
          [(formValues)]="reasonFormValues"
          [disabled]="isApplying()"
          [showFormErrors]="true"
        ></ui-form>

        <ui-button-group
          class="workspace-actions"
          [buttonsConfig]="applyActionButtons()"
          (buttonClick)="onApplyActionButtonClick($event)"
        ></ui-button-group>

        <p *ngIf="actionMessage()" class="message" data-testid="action-message">{{ actionMessage() }}</p>
      </ui-panel>
    </ui-panel>
  </ui-block>
</ui-section>
